"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3262],{

/***/ 23981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalState": function() { return /* binding */ ModalState; },
  "default": function() { return /* binding */ reminders; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/css/theme.ts
var theme = __webpack_require__(55374);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/LargeHeading.tsx



var LargeHeading_text = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    fontSize: "24px",
    lineHeight: "28px",
    fontWeight: 500
});
var LargeHeading = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
        className: LargeHeading_text,
        children: children
    });
};
/* harmony default export */ var components_LargeHeading = (LargeHeading);

;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderWrapper.tsx




var wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginTop: "1.875rem",
    flex: "1",
    overflow: "hidden",
    paddingLeft: "1.25rem",
    paddingRight: "1.25rem",
    "@media (min-width: 768px and max-width: 1279px)": {
        paddingRight: "5px",
        paddingLeft: "0px"
    },
    "@media (min-width: 1280px)": {
        marginLeft: "1.875rem"
    }
});
var headerWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    display: "flex",
    flexDirection: "row",
    marginBottom: "1.5rem"
});
var heading = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    flex: 1
});
var GiftReminderWrapper = function(param) {
    var children = param.children, headerRight = param.headerRight;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: wrapper,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: headerWrapper,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
                        className: heading,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_LargeHeading, {
                            children: "Reminders"
                        })
                    }),
                    headerRight
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var reminders_GiftReminderWrapper = (GiftReminderWrapper);

// EXTERNAL MODULE: ./src/components/pages/reminders/context/index.tsx
var context = __webpack_require__(13572);
// EXTERNAL MODULE: ./src/utils/reminder.ts
var reminder = __webpack_require__(77501);
;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderEmptyDashboard.tsx










var GiftReminderEmptyDashboard_text = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    fontSize: "24px",
    lineHeight: "28px"
});
var emptyBoardContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    backgroundColor: theme/* Color.White */.Il.White,
    paddingTop: "32px",
    paddingBottom: "32px",
    boxShadow: "0px 10px 30px rgba(209, 213, 223, 0.5)",
    borderRadius: "10px",
    paddingLeft: "2em",
    paddingRight: "2em",
    textAlign: "center",
    "@media (min-width: 768px)": {
        marginRight: "1.875rem"
    }
});
var buttonWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    width: "190px",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "24px"
});
var GiftReminderEmptyDashboard = function() {
    var ref = (0,context/* useRemindersContext */._)(), setModalState = ref.setModalState, setReminderInstanceId = ref.setReminderInstanceId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            className: emptyBoardContainer,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((image_default()), {
                    src: "/images/icon_bells.svg",
                    alt: "Bells icon",
                    width: 55,
                    height: 55
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                    className: (0,emotion_css_esm.cx)(GiftReminderEmptyDashboard_text, "set-reminder-title"),
                    children: "Set a reminder to ensure you never miss a birthday or anniversary again!"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: buttonWrapper,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                        className: "create-reminder-button",
                        type: "button",
                        variation: Button/* Variations.Primary */.b.Primary,
                        onClick: function() {
                            setReminderInstanceId((0,reminder/* generateUniqueReminderId */.v)());
                            setModalState({
                                state: ModalState.New
                            });
                        },
                        children: "Create a reminder"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var reminders_GiftReminderEmptyDashboard = (GiftReminderEmptyDashboard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
// EXTERNAL MODULE: ./src/api/queries.ts
var queries = __webpack_require__(95871);
// EXTERNAL MODULE: ./src/models/giftReminders.ts
var giftReminders = __webpack_require__(96466);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/components/pages/reminders/GiftReminderForm.tsx + 6 modules
var GiftReminderForm = __webpack_require__(45335);
;// CONCATENATED MODULE: ./src/components/Modal.tsx




var overlay = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    position: "fixed",
    left: "0px",
    right: "0px",
    top: "0px",
    bottom: "0px",
    zIndex: 1000,
    background: "rgba(49, 62, 73, 0.9)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
var Modal_wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    width: "100%",
    padding: "2rem"
});
var container = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    borderRadius: "10px",
    backgroundColor: theme/* Color.White */.Il.White,
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: "500px",
    paddingLeft: "2rem",
    paddingRight: "2rem",
    paddingTop: "1.75rem",
    paddingBottom: "1.75rem"
});
var Modal = function(param) {
    var children = param.children, className = param.className, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        "aria-hidden": true,
        className: overlay,
        onClick: function(e) {
            e.preventDefault();
            onClose();
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: Modal_wrapper,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                role: "presentation",
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: (0,emotion_css_esm.cx)([
                    container,
                    className
                ]),
                children: children
            })
        })
    });
};
/* harmony default export */ var components_Modal = (Modal);

// EXTERNAL MODULE: ./src/components/library/Notification.bs.js
var Notification_bs = __webpack_require__(88767);
;// CONCATENATED MODULE: ./src/components/Notification.tsx



var Type;
(function(Type) {
    Type[Type["Error"] = 0] = "Error";
    Type[Type["Info"] = 1] = "Info";
    Type[Type["Success"] = 2] = "Success";
    Type[Type["Warning"] = 3] = "Warning";
})(Type || (Type = {}));
var Notification = function(param) {
    var _type = param.type, type = _type === void 0 ? Type.Success : _type, title = param.title, _description = param.description, description = _description === void 0 ? "" : _description;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Notification_bs.make, {
        notificationType: type,
        title: title,
        description: description
    });
};
/* harmony default export */ var components_Notification = (Notification);

;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderItemModal.tsx















var GiftReminderItemModal_heading = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    paddingBottom: "1rem",
    whiteSpace: "nowrap"
});
var getApiQuery = function(data, uid) {
    if (!uid) {
        return (0,queries/* post */.v_)("api/v3/reminders/", data, true);
    }
    return (0,queries/* patch */.r$)("api/v3/reminders/".concat(uid, "/"), data, true);
};
var GiftReminderItemModal = function(param) {
    var _initValues = param.initValues, initValues = _initValues === void 0 ? {
        name: null,
        date: null,
        relationship: null,
        occasion: null,
        sendViaEmail: true,
        sendViaSms: true
    } : _initValues;
    var ref = (0,context/* useRemindersContext */._)(), getReminders = ref.getReminders, setNotification = ref.setNotification, modalState = ref.modalState, setModalState = ref.setModalState, reminderInstanceId = ref.reminderInstanceId;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isLoading = ref1[0], setIsLoading = ref1[1];
    var uid = modalState.uid || undefined;
    var handleClose = function() {
        setModalState({
            state: ModalState.Close
        });
    };
    /**
   * Updates or Creates the reminder
   */ var onSubmit = react.useCallback(function(data) {
        setIsLoading(true);
        var payload = (0,giftReminders/* formDataToDto */.Ef)(data);
        getApiQuery(payload, uid).then(function(response) {
            var occasion_date = payload.occasion_date, recipient_name = payload.recipient_name, occasion = payload.occasion, relationship = payload.relationship, send_via_email = payload.send_via_email, send_via_sms = payload.send_via_sms;
            var reminderUid = response.uid;
            (0,Segment_bs/* reminderSaved */.jv)({
                doe: occasion_date,
                name: recipient_name,
                occasion: occasion,
                path: router.pathname,
                relationship: relationship,
                remind_via: send_via_email && send_via_sms ? giftReminders/* ReminderVia.Both */.lr.Both : send_via_email ? giftReminders/* ReminderVia.Email */.lr.Email : giftReminders/* ReminderVia.Sms */.lr.Sms,
                reminder_id: reminderUid,
                reminder_instance_id: reminderInstanceId,
                store: "consumer",
                type: !!uid ? giftReminders/* ReminderActivityType.Save */.jw.Save : giftReminders/* ReminderActivityType.New */.jw.New
            });
            setNotification({
                type: Type.Success,
                title: !!uid ? "Your reminder has been updated!" : "Your reminder has been created!"
            });
            handleClose();
            setIsLoading(false);
            getReminders();
        }).catch(function(error) {
            logger/* default.error */.ZP.error({
                err: error,
                source: "Reminders API"
            }, "error: unable to create/update reminder");
            setIsLoading(false);
        });
    }, [
        handleClose,
        setNotification,
        uid
    ]);
    var isEdit = modalState.state === ModalState.Edit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: modalState.state !== ModalState.Close && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(components_Modal, {
            onClose: handleClose,
            className: "gift-reminder-modal",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
                    className: GiftReminderItemModal_heading,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_LargeHeading, {
                        children: isEdit ? "Edit reminder" : "Create a reminder"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GiftReminderForm/* default */.Z, {
                    onSubmit: onSubmit,
                    onCancel: handleClose,
                    uid: uid,
                    initialValues: modalState.initValues || initValues,
                    isLoading: isLoading,
                    saveBtnText: isEdit ? "Save" : undefined,
                    cancelBtnText: isEdit ? "Cancel" : undefined,
                    loadingBtnText: isEdit ? "Saving..." : undefined,
                    reminderInstanceId: reminderInstanceId
                })
            ]
        })
    });
};
/* harmony default export */ var reminders_GiftReminderItemModal = (GiftReminderItemModal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/spacetime/builds/spacetime.mjs
var spacetime = __webpack_require__(79402);
;// CONCATENATED MODULE: ./src/components/MenuList.tsx




var MenuList_wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    borderRadius: theme/* Styles.BorderRadius */.z0.BorderRadius,
    background: theme/* Color.White */.Il.White,
    boxShadow: "0px 10px 30px rgba(209, 213, 223, 0.5)",
    borderColor: theme/* Color.BackgroundGray */.Il.BackgroundGray,
    borderWidth: "1px"
});
var itemWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    cursor: "pointer",
    minWidth: "150px",
    borderRadius: theme/* Styles.BorderRadius */.z0.BorderRadius,
    ":hover": {
        backgroundColor: theme/* Color.LightBlue */.Il.LightBlue,
        color: theme/* Color.PrimaryBlue */.Il.PrimaryBlue
    }
});
var MenuList_buttonWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    width: "100%",
    fontWeight: 500,
    padding: "16px",
    textAlign: "left"
});
function MenuList(param, ref) {
    var items = param.items;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("ul", {
        ref: ref,
        className: MenuList_wrapper,
        children: items.map(function(i) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("li", {
                className: itemWrapper,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                    className: MenuList_buttonWrapper,
                    onClick: i.onClick,
                    children: i.text
                })
            }, i.value.id);
        })
    });
}
/* harmony default export */ var components_MenuList = (/*#__PURE__*/react.forwardRef(MenuList));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderDeleteConfirmModal.tsx









var GiftReminderDeleteConfirmModal_wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});
var GiftReminderDeleteConfirmModal_buttonWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    display: "flex",
    flexDirection: "row",
    marginTop: "1.5rem",
    width: "100%",
    "> button + button": {
        marginLeft: "16px",
        "@media (max-width: 640px)": {
            marginLeft: "0px",
            marginTop: "10px"
        }
    },
    "@media (max-width: 640px)": {
        flexDirection: "column"
    }
});
var detailsWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginTop: "1.5rem"
});
var GiftReminderDeleteConfirmModal = function(param) {
    var children = param.children, title = param.title, description = param.description;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(null), callback = ref1[0], setCallback = ref1[1];
    var show = function(callback, tracking) {
        return function(event) {
            event.preventDefault();
            if (tracking) {
                (0,Segment_bs/* customElementInteraction */.pA)(tracking);
            }
            setOpen(true);
            event = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
                target: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event.target), {
                    value: event.target.value
                })
            });
            setCallback({
                run: function() {
                    return callback(event);
                }
            });
        };
    };
    var hide = function() {
        setCallback(null);
        setOpen(false);
    };
    var confirm = function() {
        callback.run();
        hide();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            children(show),
            open && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_Modal, {
                onClose: hide,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: GiftReminderDeleteConfirmModal_wrapper,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_LargeHeading, {
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: detailsWrapper,
                            children: description
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: GiftReminderDeleteConfirmModal_buttonWrapper,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                    onClick: hide,
                                    variation: Button/* Variations.Outlined */.b.Outlined,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                    onClick: confirm,
                                    variation: Button/* Variations.Primary */.b.Primary,
                                    children: "Delete"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var reminders_GiftReminderDeleteConfirmModal = (GiftReminderDeleteConfirmModal);

;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderItem.tsx
















var GiftReminderItem_wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    backgroundColor: theme/* Color.White */.Il.White,
    "& + &": {
        marginTop: "16px"
    },
    padding: "12px",
    position: "relative",
    boxShadow: "0px 10px 30px rgba(209, 213, 223, 0.5)",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (min-width: 1024px)": {
        padding: "26px"
    }
});
var leftInnerContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    display: "flex",
    width: "80%",
    alignItems: "center"
});
var rightInnerContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    display: "flex",
    alignItems: "center",
    justifyContent: "end"
});
var iconImage = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    width: "40px",
    height: "40px",
    marginRight: "12px",
    "@media (min-width: 768px)": {
        width: "55px",
        height: "55px",
        marginRight: "22px"
    }
});
var title = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    fontSize: "18px",
    lineHeight: "21px",
    paddingBottom: "6px",
    "@media (min-width: 768px)": {
        fontSize: "24px",
        lineHeight: "28px"
    }
});
var date = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    fontSize: "14px",
    lineHeight: "19px",
    color: theme/* Color.BorderGray */.Il.BorderGray,
    "@media (min-width: 768px)": {
        fontSize: "16px",
        lineHeight: "22px"
    },
    "> span": {
        fontWeight: 600
    }
});
var icon = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginLeft: "22px"
});
var GiftReminderItem_link = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    color: theme/* Color.PrimaryBlue */.Il.PrimaryBlue,
    textDecoration: "underline"
});
var menuWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    position: "absolute",
    right: "0px",
    top: "-10px",
    zIndex: 10
});
var getDisplayDate = function(ref) {
    var rtf = new Intl.RelativeTimeFormat("en", {
        style: "short"
    });
    var today = new Date();
    var diff = Math.floor((ref.setHours(10) - today.setHours(9)) / (1000 * 3600 * 24));
    var getDiffStr = function() {
        return diff === 0 ? "today" : rtf.format(diff, "day");
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
        children: " - It's ".concat(getDiffStr(), "!")
    });
};
var GiftReminderItem = function(param) {
    var item = param.item, showMenu = param.showMenu, setShowMenu = param.setShowMenu, menuRef = param.menuRef;
    var ref = (0,context/* useRemindersContext */._)(), setModalState = ref.setModalState, getReminders = ref.getReminders, setNotification = ref.setNotification;
    var router = (0,next_router.useRouter)();
    var itemDate = new Date(item.nextOccurrenceDate);
    var displayDate = (0,spacetime/* default */.Z)(itemDate).format("{date-pad} {month-short}");
    var handleDelete = function() {
        (0,queries/* remove */.Od)("api/v3/reminders/".concat(item.uid, "/"), undefined, true).then(function() {
            setNotification({
                type: Type.Success,
                title: "Your reminder has been deleted."
            });
            getReminders();
        }).catch(function(error) {
            logger/* default.error */.ZP.error({
                err: error,
                source: "Reminders API"
            }, "error: unable to delete reminder");
        });
    };
    var handleEdit = function() {
        (0,Segment_bs/* customElementInteraction */.pA)({
            element: "my_reminders_edit",
            reminder_id: item.uid,
            path: router.pathname
        });
        setShowMenu(null);
        setModalState({
            state: ModalState.Edit,
            initValues: {
                name: item.recipientName,
                occasion: {
                    value: item.occasion.uid,
                    label: item.occasion.title,
                    iconUrl: item.occasion.thumbImage,
                    hoverIconUrl: item.occasion.hoverImage
                },
                relationship: {
                    value: item.relationship.uid,
                    label: item.relationship.title
                },
                date: new Date(item.nextOccurrenceDate),
                sendViaEmail: item.sendViaEmail,
                sendViaSms: item.sendViaSms
            },
            uid: item.uid
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderDeleteConfirmModal, {
        title: "Delete reminder",
        description: "Once you delete this reminder it cannot be undone.",
        children: function(confirm) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: GiftReminderItem_wrapper,
                children: [
                    showMenu && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: menuWrapper,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_MenuList, {
                            ref: menuRef,
                            items: [
                                {
                                    text: "Edit",
                                    value: {
                                        id: "edit"
                                    },
                                    onClick: handleEdit
                                },
                                {
                                    text: "Delete",
                                    value: {
                                        id: "delete"
                                    },
                                    onClick: confirm(handleDelete, {
                                        element: "my_reminders_delete",
                                        reminder_id: item.uid,
                                        path: router.pathname
                                    })
                                }, 
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: leftInnerContainer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("img", {
                                src: item.occasion.iconImage,
                                alt: item.occasion.title,
                                className: iconImage
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: title,
                                        children: item.heading
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                        className: date,
                                        children: [
                                            displayDate,
                                            " ",
                                            getDisplayDate(itemDate)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: rightInnerContainer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                href: "/store",
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    className: GiftReminderItem_link,
                                    onClick: function() {
                                        (0,Segment_bs/* customElementInteraction */.pA)({
                                            element: "my_reminders_shop",
                                            path: router.pathname
                                        });
                                    },
                                    children: "Shop"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                className: "".concat(icon, " menu-btn"),
                                onClick: function() {
                                    setShowMenu(item.uid);
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "ellipsis-v"
                                    ],
                                    pointerEvents: "none"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var reminders_GiftReminderItem = (GiftReminderItem);

// EXTERNAL MODULE: ./src/components/library/PaginationContainer.bs.js + 1 modules
var PaginationContainer_bs = __webpack_require__(39812);
;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderList.tsx













var rightWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    flex: 1
});
var GiftReminderList_buttonWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    width: "160px",
    "@media (min-width: 768px)": {
        width: "190px"
    },
    float: "right"
});
var GiftReminderList_wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    display: "flex"
});
var innerWrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    width: "100%",
    "@media (min-width: 1280px)": {
        width: "55%"
    }
});
var paginationContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    maxWidth: "23.0->rem"
});
var footer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginTop: "1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 640px)": {
        flexDirection: "column",
        justifyContent: "center"
    }
});
var footerText = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    "@media (max-width: 640px)": {
        display: "none"
    }
});
var monthTitle = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    fontSize: "18px",
    lineHeight: "21px",
    paddingBottom: "8px",
    paddingTop: "24px",
    fontWeight: 500
});
var toReminderList = function(results) {
    return results.reduce(function(carry, item) {
        var itemMonth = (0,spacetime/* default */.Z)(item.nextOccurrenceDate).format("{month} {year}");
        var existing = carry[itemMonth];
        carry[itemMonth] = (0,_to_consumable_array/* default */.Z)(existing || []).concat([
            item
        ]);
        return carry;
    }, {});
};
var GiftReminderList = function(param) {
    var count = param.count, currentPage = param.currentPage, pageSize = param.pageSize, results = param.results;
    var totalReminders = results.length;
    var fromCount = (currentPage - 1) * pageSize + 1;
    var toCount = (currentPage - 1) * pageSize + totalReminders;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), menuId = ref[0], setMenuId = ref[1];
    var menuRef = react.useRef();
    var resultsGrouped = toReminderList(results);
    var ref1 = (0,context/* useRemindersContext */._)(), setModalState = ref1.setModalState, setReminderInstanceId = ref1.setReminderInstanceId;
    var handleClosure = react.useCallback(function(event) {
        if (menuRef.current && !menuRef.current.contains(event.target) && !!menuId && !event.target.classList.contains("menu-btn")) {
            setMenuId(null);
        }
    }, [
        menuId
    ]);
    react.useEffect(function() {
        window.addEventListener("click", handleClosure);
        return function() {
            window.removeEventListener("click", handleClosure);
        };
    }, [
        handleClosure
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderWrapper, {
        headerRight: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: rightWrapper,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: GiftReminderList_buttonWrapper,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                    className: "create-reminder-button",
                    type: "button",
                    variation: Button/* Variations.Primary */.b.Primary,
                    onClick: function() {
                        setReminderInstanceId((0,reminder/* generateUniqueReminderId */.v)());
                        setModalState({
                            state: ModalState.New
                        });
                    },
                    children: "Create a reminder"
                })
            })
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: GiftReminderList_wrapper,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: innerWrapper,
                children: [
                    Object.keys(resultsGrouped).map(function(key) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: monthTitle,
                                    children: key
                                }),
                                resultsGrouped[key].map(function(item) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderItem, {
                                        menuRef: menuRef,
                                        showMenu: menuId === item.uid,
                                        setShowMenu: function(id) {
                                            return setMenuId(id);
                                        },
                                        item: item
                                    }, item.uid);
                                })
                            ]
                        }, key);
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: footer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: footerText,
                                children: [
                                    "Showing",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("b", {
                                        children: [
                                            fromCount,
                                            "-",
                                            toCount
                                        ]
                                    }),
                                    " ",
                                    "out of ",
                                    count,
                                    " reminders"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PaginationContainer_bs/* make */.Sy, {
                                count: count,
                                currentPage: currentPage,
                                pageSize: pageSize,
                                className: paginationContainer,
                                urlConstructor: function(pageNum) {
                                    return "/reminders/?page=".concat(pageNum);
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var reminders_GiftReminderList = (/*#__PURE__*/react.memo(GiftReminderList));

;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderNotification.tsx





var GiftReminderNotification_wrapper = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    position: "absolute",
    right: "0.625rem",
    zIndex: 5,
    top: "110px",
    "@media (max-width: 1288px)": {
        top: "90px"
    },
    "@media (max-width: 768px)": {
        margin: "1.25rem !important",
        right: "0px",
        left: "0px",
        marginTop: "0 !important"
    }
});
var GiftReminderNotification = function() {
    var ref = (0,context/* useRemindersContext */._)(), notification = ref.notification, setNotification = ref.setNotification;
    (0,react.useEffect)(function() {
        var timer;
        if (notification) {
            timer = setTimeout(function() {
                setNotification(null);
            }, 3000);
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        notification
    ]);
    if (notification) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: GiftReminderNotification_wrapper,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_Notification, {
                type: notification.type,
                title: notification.title
            })
        });
    }
    return null;
};
/* harmony default export */ var reminders_GiftReminderNotification = (GiftReminderNotification);

// EXTERNAL MODULE: ./src/components/pages/myAccount/Container.bs.js + 3 modules
var Container_bs = __webpack_require__(22339);
// EXTERNAL MODULE: ./src/components/Spinner.tsx
var Spinner = __webpack_require__(95433);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/api/client.ts + 5 modules
var client = __webpack_require__(86723);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query-devtools/build/lib/index.mjs
var lib = __webpack_require__(90041);
;// CONCATENATED MODULE: ./src/pages/reminders/reminders.tsx

__webpack_require__(14473);












var ModalState;
(function(ModalState) {
    ModalState[ModalState["New"] = 0] = "New";
    ModalState[ModalState["Edit"] = 1] = "Edit";
    ModalState[ModalState["Close"] = 2] = "Close";
})(ModalState || (ModalState = {}));
var Reminders = function() {
    var EmptyDashBoard = react.useCallback(function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderEmptyDashboard, {});
    }, []);
    var Children = function() {
        var ref = (0,context/* useRemindersContext */._)(), _remindersData = ref.remindersData, remindersData = _remindersData === void 0 ? {
            count: 0,
            next: null,
            page_number: 1,
            page_size: 5,
            previous: null,
            results: []
        } : _remindersData, status = ref.status;
        switch(status){
            case "success":
                {
                    var data = {
                        pageNumber: remindersData.page_number,
                        pageSize: remindersData.page_size,
                        count: remindersData.count,
                        next: remindersData.next,
                        previous: remindersData.previous,
                        results: remindersData.results
                    };
                    return Object.keys(remindersData.results).length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EmptyDashBoard, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderList, {
                        count: data.count,
                        currentPage: data.pageNumber,
                        pageSize: data.pageSize,
                        results: data.results
                    });
                }
            case "error":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EmptyDashBoard, {});
            case "loading":
            default:
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Spinner/* default */.Z, {})
                });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(QueryClientProvider/* QueryClientProvider */.aH, {
        client: client/* default */.Z,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Container_bs/* make */.S, {
                children: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(context/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderItemModal, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(reminders_GiftReminderNotification, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Children, {})
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib/* ReactQueryDevtools */.t, {
                initialIsOpen: false
            })
        ]
    });
};
/* harmony default export */ var reminders = (Reminders);


/***/ }),

/***/ 95871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Od": function() { return /* binding */ remove; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "r$": function() { return /* binding */ patch; },
/* harmony export */   "v_": function() { return /* binding */ post; }
/* harmony export */ });
/* unused harmony export getFile */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var auth_user_AuthUtils_bs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45603);
/* harmony import */ var config_Config_bs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43217);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_authUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89090);







var getUrl = function(subRoute) {
    return "".concat("https://www.prezzee.com/").concat(subRoute);
};
var getHeaders = function() {
    var withAuth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, withMagicUserAgentOnServerOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var headers = {
        "content-type": "application/json",
        accept: "application/json"
    };
    var fingerprint = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("fingerprint-pz");
    if (fingerprint) headers["x-device-fingerprint"] = fingerprint;
    if (withAuth) {
        var userCookie = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get(auth_user_AuthUtils_bs__WEBPACK_IMPORTED_MODULE_0__/* .cookieName */ .YN);
        var decryptedUser = userCookie ? (0,utils_authUtils__WEBPACK_IMPORTED_MODULE_2__/* .decryptUserCookie */ .x)(userCookie) : undefined;
        var isMasq = decryptedUser === null || decryptedUser === void 0 ? void 0 : decryptedUser.masquerade;
        var tokenType = isMasq ? "Masq" : "Bearer";
        headers["Authorization"] = "".concat(tokenType, " ").concat((0,auth_user_AuthUtils_bs__WEBPACK_IMPORTED_MODULE_0__/* .getToken */ .LP)());
    }
    if (withMagicUserAgentOnServerOnly) headers["User-Agent"] = config_Config_bs__WEBPACK_IMPORTED_MODULE_3__/* .magicUserAgentHeader */ .YI;
    return headers;
};
var get = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(url, options) {
        var defaultOptions, options_, res, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    defaultOptions = {
                        withAuth: false,
                        withMagicUserAgentOnServerOnly: false
                    };
                    options_ = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultOptions, options);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(getUrl(url), {
                            method: "GET",
                            headers: getHeaders(options_.withAuth, options_.withMagicUserAgentOnServerOnly)
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    e = _state.sent();
                    throw e;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function get(url, options) {
        return _ref.apply(this, arguments);
    };
}();
var getFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(url) {
        var withAuth, res, blob, e;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    withAuth = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(getUrl(url), {
                            method: "GET",
                            headers: getHeaders(withAuth)
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        4,
                        res.blob()
                    ];
                case 3:
                    blob = _state.sent();
                    return [
                        2,
                        blob
                    ];
                case 4:
                    e = _state.sent();
                    throw e;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getFile(url) {
        return _ref.apply(this, arguments);
    };
}();
var update = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(method, url, data) {
        var withAuth, res, e, e1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    withAuth = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        fetch(getUrl(url), {
                            method: method,
                            headers: getHeaders(withAuth),
                            mode: "cors",
                            credentials: "same-origin",
                            body: data ? JSON.stringify(data) : undefined
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        6
                    ];
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        res.json()
                    ];
                case 4:
                    return [
                        2,
                        _state.sent()
                    ];
                case 5:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 6:
                    return [
                        2,
                        null
                    ];
                case 7:
                    e1 = _state.sent();
                    throw e1;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function update(method, url, data) {
        return _ref.apply(this, arguments);
    };
}();
var post = function(url, data) {
    var withAuth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return update("POST", url, data, withAuth);
};
var patch = function(url, data) {
    var withAuth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return update("PATCH", url, data, withAuth);
};
var remove = function(url, data) {
    var withAuth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return update("DELETE", url, data, withAuth);
};


/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Variations; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LottieController_LottieController_gen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14713);
/* harmony import */ var css_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55374);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





// eslint-disable-next-line import/extensions



var Variations;
(function(Variations) {
    Variations["Primary"] = "Primary";
    Variations["Outlined"] = "Outlined";
})(Variations || (Variations = {}));
var getStylesFromVariation = function(disabled, variation) {
    switch(variation){
        case Variations.Outlined:
            return {
                borderWidth: "1px",
                borderColor: disabled ? css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.LightGray */ .Il.LightGray : css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.DarkGray */ .Il.DarkGray,
                color: disabled ? css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.LightGray */ .Il.LightGray : css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.DarkGray */ .Il.DarkGray
            };
        case Variations.Primary:
        default:
            return {
                backgroundColor: disabled ? css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.LightGray */ .Il.LightGray : css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.Primary */ .Il.Primary,
                color: css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.White */ .Il.White
            };
    }
};
var container = function(loading, disabled, variation) {
    return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "100%",
        paddingLeft: "auto",
        paddingRight: "auto",
        paddingTop: "0.875rem",
        paddingBottom: "0.875rem",
        borderRadius: "10px",
        fontWeight: 600,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        cursor: loading || disabled ? "not-allowed" : "pointer"
    }, getStylesFromVariation(!loading && disabled, variation)));
};
var loadingIcon = /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)({
    width: "1.5rem",
    marginRight: "10px",
    fill: css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.White */ .Il.White,
    stroke: css_theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.White */ .Il.White
});
var Button = function(_param) /*#__PURE__*/ {
    var variation = _param.variation, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, onClick = _param.onClick, _type = _param.type, type = _type === void 0 ? "button" : _type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "variation",
        "loading",
        "disabled",
        "children",
        "className",
        "onClick",
        "type"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        onClick: onClick
    }, props), {
        className: (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__.cx)(container(loading, disabled, variation), className),
        disabled: disabled,
        type: type,
        children: [
            loading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_prezzee_ribbon_src_components_personal_LottieController_LottieController_gen__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                className: loadingIcon,
                path: "https://assets7.lottiefiles.com/packages/lf20_ly6t7nzc.json"
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 95433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LottieController_LottieController_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80873);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);


// eslint-disable-next-line import/extensions


var container = /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)({
    width: "100%",
    display: "flex",
    justifyContent: "center"
});
var icon = /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)({
    width: "45px"
});
var Spinner = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: container,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_prezzee_ribbon_src_components_personal_LottieController_LottieController_bs_js__WEBPACK_IMPORTED_MODULE_1__.make, {
            className: icon,
            path: "https://assets5.lottiefiles.com/packages/lf20_p5zcfhtp.json"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 45335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reminders_GiftReminderForm; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./src/css/theme.ts
var theme = __webpack_require__(55374);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./src/api/queries.ts
var queries = __webpack_require__(95871);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/FormInputError.tsx




var errorContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    color: theme/* Color.Error */.Il.Error
});
var FormInputError = function(param) {
    var error = param.error;
    return !!error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: errorContainer,
        children: error
    });
};
/* harmony default export */ var components_FormInputError = (FormInputError);

;// CONCATENATED MODULE: ./src/components/FormControlWrapper.tsx







var FormControlWrapper_errorContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    borderColor: "".concat(theme/* Color.Error */.Il.Error, " !important")
});
var FormControlWrapper = function(param) {
    var labelVisible = param.labelVisible, children = param.children, error = param.error, label = param.label, _className = param.className, className = _className === void 0 ? "" : _className;
    var errorStr = error === null || error === void 0 ? void 0 : error.message;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "inputContainer",
                children: [
                    children(label, !!errorStr ? FormControlWrapper_errorContainer : ""),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, labelVisible !== undefined ? {
                        className: labelVisible ? "labelText" : "labelTextHidden"
                    } : {}), {
                        children: label
                    }))
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormInputError, {
                error: errorStr
            })
        ]
    });
};
/* harmony default export */ var components_FormControlWrapper = (FormControlWrapper);

;// CONCATENATED MODULE: ./src/components/FormInput.tsx




var FormInput = function(param, ref) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, name = param.name, autoComplete = param.autoComplete, placeholder = param.placeholder, error = param.error, _className = param.className, className = _className === void 0 ? "" : _className, onChange = param.onChange, onBlur = param.onBlur, defaultValue = param.defaultValue;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormControlWrapper, {
        error: error,
        label: placeholder,
        className: className,
        children: function(_, errorClassName) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", (0,_object_spread/* default */.Z)({
                className: errorClassName,
                name: name,
                disabled: disabled,
                ref: ref,
                placeholder: placeholder,
                onBlur: onBlur
            }, autoComplete ? {
                autoComplete: autoComplete
            } : {}, onChange ? {
                onChange: onChange
            } : {}, defaultValue ? {
                defaultValue: defaultValue
            } : {}));
        }
    });
};
/* harmony default export */ var components_FormInput = (/*#__PURE__*/react.forwardRef(FormInput));

// EXTERNAL MODULE: ./node_modules/react-select/dist/index-c7a4d7ce.esm.js + 3 modules
var index_c7a4d7ce_esm = __webpack_require__(40044);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 12 modules
var react_select_esm = __webpack_require__(41832);
;// CONCATENATED MODULE: ./src/components/FormSelect.tsx








var optionContainer = function(url, hoverUrl) {
    return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
        backgroundImage: "url(".concat(url, ")"),
        backgroundRepeat: "no-repeat",
        backgroundSize: "16px",
        ":hover": {
            backgroundImage: "url(".concat(hoverUrl, ")"),
            color: theme/* Color.PrimaryBlue */.Il.PrimaryBlue
        }
    });
};
var Option = index_c7a4d7ce_esm.c.Option;
var CustomOption = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: props.data.iconUrl ? optionContainer(props.data.iconUrl, props.data.hoverIconUrl) : "",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.data.iconUrl ? {
                style: {
                    paddingLeft: "26px"
                }
            } : {}), {
                children: props.data.label
            }))
        })
    }));
};
var FormSelect = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, placeholder = param.placeholder, options = param.options, name = param.name, value = param.value, onChange = param.onChange, error = param.error, onBlur = param.onBlur;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormControlWrapper, {
        labelVisible: !!value,
        error: error,
        label: placeholder,
        children: function(_, errorClassName) {
            var isInvalid = !!errorClassName;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react_select_esm/* default */.ZP, {
                "aria-invalid": isInvalid,
                "aria-label": name,
                value: value,
                instanceId: name,
                isDisabled: disabled,
                styles: {
                    control: function(provided, state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                            paddingTop: "4px",
                            paddingBottom: "4px",
                            paddingLeft: "10px",
                            borderRadius: "10px",
                            borderColor: isInvalid ? theme/* Color.Error */.Il.Error : theme/* Color.BorderGray */.Il.BorderGray,
                            boxShadow: "none",
                            "&:hover": {
                                borderColor: isInvalid ? theme/* Color.Error */.Il.Error : theme/* Color.BorderGray */.Il.BorderGray
                            },
                            backgroundColor: state.isDisabled ? "rgba(59, 59, 59, 0.02)" : theme/* Color.White */.Il.White
                        });
                    },
                    placeholder: function(provided) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                            color: theme/* Color.InactiveGray */.Il.InactiveGray
                        });
                    },
                    option: function(provided) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                            display: "flex",
                            flexDirection: "row",
                            padding: "12px 15px"
                        });
                    },
                    input: function(provided) {
                        return (0,_object_spread/* default */.Z)({}, provided);
                    },
                    menu: function(provided) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                            marginTop: "0px",
                            border: "none",
                            boxShadow: "4px 4px 25px rgba(0, 0, 0, 0.2)"
                        });
                    }
                },
                components: {
                    Option: CustomOption
                },
                placeholder: placeholder,
                onChange: function(data) {
                    return onChange(data);
                },
                onBlur: onBlur,
                options: options
            });
        }
    });
};
/* harmony default export */ var components_FormSelect = (FormSelect);

// EXTERNAL MODULE: ./src/models/giftReminders.ts
var giftReminders = __webpack_require__(96466);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
;// CONCATENATED MODULE: ./src/components/FormCheckbox.tsx






var label = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    userSelect: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
var FormCheckbox_checkbox = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginRight: "0.75rem",
    width: "1.125rem",
    height: "1.125rem",
    color: theme/* Color.DarkGray */.Il.DarkGray,
    marginTop: "0.125rem",
    borderColor: theme/* Color.BorderGray */.Il.BorderGray,
    ":disabled": {
        color: theme/* Color.LightGray */.Il.LightGray
    }
});
var FormCheckbox = function(param, ref) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children, name = param.name, error = param.error, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("label", {
                className: label,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", (0,_object_spread/* default */.Z)({
                        disabled: disabled,
                        className: "form-checkbox ".concat(FormCheckbox_checkbox),
                        id: name,
                        ref: ref,
                        name: name,
                        type: "checkbox"
                    }, onClick ? {
                        onClick: onClick
                    } : {})),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormInputError, {
                error: error === null || error === void 0 ? void 0 : error.message
            })
        ]
    });
};
/* harmony default export */ var components_FormCheckbox = (/*#__PURE__*/react.forwardRef(FormCheckbox));

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
;// CONCATENATED MODULE: ./src/components/FormDatePicker.tsx







var popperClass = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginTop: "5px !important"
});
var container = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    position: "relative"
});
var icon = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    position: "absolute",
    top: "12px",
    right: "12px"
});
var FormDatePicker = function(param) {
    var value = param.value, onChange = param.onChange, dateFormat = param.dateFormat, placeholder = param.placeholder, renderCustomHeader = param.renderCustomHeader, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, error = param.error, minDate = param.minDate, onBlur = param.onBlur;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormControlWrapper, {
        labelVisible: !!value,
        error: error,
        label: placeholder,
        children: function(_, errorClassName) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: container,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((react_datepicker_min_default()), (0,_object_spread/* default */.Z)({
                        disabled: disabled,
                        className: errorClassName,
                        placeholderText: placeholder,
                        onChange: function(date) {
                            return onChange(date);
                        },
                        onBlur: onBlur,
                        selected: value,
                        popperClassName: popperClass,
                        dateFormat: dateFormat,
                        minDate: minDate
                    }, renderCustomHeader ? {
                        renderCustomHeader: renderCustomHeader
                    } : {})),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: icon,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                            icon: [
                                "far",
                                "calendar-alt"
                            ]
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var components_FormDatePicker = (FormDatePicker);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/utils/reminder.ts
var reminder = __webpack_require__(77501);
;// CONCATENATED MODULE: ./src/components/pages/reminders/GiftReminderForm.tsx


















var checkboxContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    marginTop: "8px",
    display: "flex",
    ">div+div": {
        marginLeft: "2.25rem"
    },
    marginBottom: "5px",
    ">legend": {
        marginBottom: "8px",
        fontWeight: 600
    }
});
var fieldsetContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    "> div+div": {
        marginTop: "16px"
    },
    ":disabled": {
        input: {
            color: theme/* Color.LightGray */.Il.LightGray
        }
    }
});
var formContainer = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    "> fieldset+fieldset": {
        marginTop: "16px"
    }
});
var activeText = /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
    color: theme/* Color.PrimaryBlue */.Il.PrimaryBlue,
    marginTop: "5px !important"
});
var GiftReminderForm = function(param) {
    var onSubmit = param.onSubmit, initialValues = param.initialValues, uid = param.uid, onCancel = param.onCancel, _saveBtnText = param.saveBtnText, saveBtnText = _saveBtnText === void 0 ? "Create reminder" : _saveBtnText, _loadingBtnText = param.loadingBtnText, loadingBtnText = _loadingBtnText === void 0 ? "Your reminder is being created..." : _loadingBtnText, _cancelBtnText = param.cancelBtnText, cancelBtnText = _cancelBtnText === void 0 ? "No thanks" : _cancelBtnText, isLoading = param.isLoading, _reminderInstanceId = param.reminderInstanceId, reminderInstanceId = _reminderInstanceId === void 0 ? (0,reminder/* generateUniqueReminderId */.v)() : _reminderInstanceId;
    var router = (0,next_router.useRouter)();
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "all",
        reValidateMode: "onChange",
        defaultValues: initialValues,
        criteriaMode: "firstError",
        shouldFocusError: true
    }), register = ref.register, handleSubmit = ref.handleSubmit, control = ref.control, errors = ref.errors, getValues = ref.getValues, trigger = ref.trigger, formState = ref.formState;
    var ref1 = (0,useQuery/* useQuery */.a)([
        "relationships"
    ], function() {
        return (0,queries/* get */.U2)("api/v3/reminders/relationships/", {
            withAuth: true
        }).then(function(data) {
            return data.map(giftReminders/* toSelectOption */.P4);
        });
    }, {
        staleTime: 1000 * 60 * 5
    }), relationships = ref1.data, isRelationshipError = ref1.isError, relationshipLoading = ref1.isLoading, relationshipError = ref1.error;
    if (isRelationshipError) {
        logger/* default.error */.ZP.error({
            err: relationshipError,
            source: "Reminders API"
        }, "error: unable to retrieve relationship data");
    }
    var ref2 = (0,useQuery/* useQuery */.a)([
        "occasions"
    ], function() {
        return (0,queries/* get */.U2)("api/v3/reminders/occasions/", {
            withAuth: true
        }).then(function(data) {
            return data.map(giftReminders/* toSelectOption */.P4);
        });
    }, {
        staleTime: 1000 * 60 * 5
    }), occasions = ref2.data, isOccasionError = ref2.isError, occasionLoading = ref2.isLoading, occasionError = ref2.error;
    if (isOccasionError) {
        logger/* default.error */.ZP.error({
            err: occasionError,
            source: "Reminders API"
        }, "error: unable to retrieve occasion data");
    }
    var disabled = formState.isSubmitting;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: formContainer,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("fieldset", {
                className: fieldsetContainer,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormInput, {
                        disabled: disabled,
                        autoComplete: "name",
                        name: "name",
                        placeholder: "Name of recipient",
                        ref: register({
                            required: "Please enter a name"
                        }),
                        className: "name-input",
                        onBlur: function() {
                            (0,Segment_bs/* customElementInteraction */.pA)({
                                element: "my_reminders_name",
                                reminder_instance_id: reminderInstanceId,
                                reminder_id: uid,
                                path: router.pathname
                            });
                        },
                        error: errors.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "occasion",
                        rules: {
                            required: "Please select an occasion"
                        },
                        render: function(param) {
                            var onChange = param.onChange, value = param.value, name = param.name;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormSelect, {
                                disabled: disabled,
                                placeholder: "Occasion",
                                name: name,
                                onChange: onChange,
                                onBlur: function() {
                                    (0,Segment_bs/* customElementInteraction */.pA)({
                                        element: "my_reminders_occasion",
                                        reminder_instance_id: reminderInstanceId,
                                        reminder_id: uid,
                                        path: router.pathname
                                    });
                                },
                                value: value,
                                error: errors[name],
                                options: occasionLoading ? [] : occasions
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "relationship",
                        rules: {
                            required: "Please select a relationship"
                        },
                        render: function(param) {
                            var onChange = param.onChange, value = param.value, name = param.name;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormSelect, {
                                disabled: disabled,
                                placeholder: "Relationship",
                                name: name,
                                onChange: onChange,
                                onBlur: function() {
                                    (0,Segment_bs/* customElementInteraction */.pA)({
                                        element: "my_reminders_relationship",
                                        reminder_instance_id: reminderInstanceId,
                                        reminder_id: uid,
                                        path: router.pathname
                                    });
                                },
                                value: value,
                                error: errors[name],
                                options: relationshipLoading ? [] : relationships
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "date",
                        rules: {
                            required: "Please select a date"
                        },
                        render: function(param) {
                            var onChange = param.onChange, value = param.value, name = param.name;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormDatePicker, {
                                placeholder: "Date of event",
                                onChange: function(date) {
                                    (0,Segment_bs/* customElementInteraction */.pA)({
                                        element: "my_reminders_doe",
                                        reminder_instance_id: reminderInstanceId,
                                        reminder_id: uid,
                                        path: router.pathname
                                    });
                                    onChange(date);
                                },
                                value: value,
                                error: errors[name],
                                disabled: disabled,
                                minDate: new Date(),
                                renderCustomHeader: function(param) {
                                    var date = param.date, decreaseMonth = param.decreaseMonth, increaseMonth = param.increaseMonth;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                                onClick: decreaseMonth,
                                                type: "button",
                                                className: "react-datepicker__navigation react-datepicker__navigation--previous",
                                                "aria-label": "Previous Month",
                                                children: "Previous Month"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                className: "react-datepicker__current-month",
                                                children: date.toLocaleString("default", {
                                                    month: "long"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                                onClick: increaseMonth,
                                                type: "button",
                                                className: "react-datepicker__navigation react-datepicker__navigation--next",
                                                "aria-label": "Next Month",
                                                children: "Next Month"
                                            })
                                        ]
                                    });
                                },
                                dateFormat: "dd/MMM"
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: activeText,
                        children: "We’ll remind you 3 days before"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("legend", {
                        children: "Remind me via"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: checkboxContainer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormCheckbox, {
                                ref: register({
                                    validate: function(data) {
                                        var sendViaSmsState = getValues().sendViaSms;
                                        return data || sendViaSmsState;
                                    }
                                }),
                                disabled: disabled,
                                onClick: function() {
                                    trigger("sendViaSms");
                                },
                                name: "sendViaEmail",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormCheckbox, {
                                ref: register({
                                    validate: function(data) {
                                        var sendViaEmailState = getValues().sendViaEmail;
                                        return data || sendViaEmailState;
                                    }
                                }),
                                disabled: disabled,
                                onClick: function() {
                                    trigger("sendViaEmail");
                                },
                                name: "sendViaSms",
                                children: "SMS"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_FormInputError, {
                        error: !!errors.sendViaEmail || !!errors.sendViaSms ? "Selection required" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("fieldset", {
                className: fieldsetContainer,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                            disabled: !formState.isValid || !formState.isDirty || disabled,
                            type: "submit",
                            variation: Button/* Variations.Primary */.b.Primary,
                            loading: isLoading,
                            children: isLoading ? loadingBtnText : saveBtnText
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                            disabled: disabled,
                            type: "button",
                            variation: Button/* Variations.Outlined */.b.Outlined,
                            onClick: onCancel,
                            children: cancelBtnText
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var reminders_GiftReminderForm = (GiftReminderForm);


/***/ }),

/***/ 13572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useRemindersContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var api_queries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95871);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31611);
/* harmony import */ var models_giftReminders__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96466);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pages_reminders_reminders__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23981);
/* harmony import */ var utils_reminder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77501);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67848);
/* harmony import */ var api_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86723);













var RemindersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var useRemindersContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RemindersContext);
    if (!context) {
        throw new Error("useRemindersContext must be used within a RemindersProvider");
    }
    return context;
};
var RemindersProvider = function(param) {
    var children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState((0,utils_reminder__WEBPACK_IMPORTED_MODULE_8__/* .generateUniqueReminderId */ .v)()), 2), reminderInstanceId = ref[0], setReminderInstanceId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), notification = ref1[0], setNotification = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("1"), pageNumber = ref2[0], setPageNumber = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        state: pages_reminders_reminders__WEBPACK_IMPORTED_MODULE_5__.ModalState.Close
    }), 2), modalState = ref3[0], setModalState = ref3[1];
    var ref4 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useQuery */ .a)({
        queryKey: [
            "reminders",
            pageNumber
        ],
        queryFn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,api_queries__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)("api/v3/reminders/?page= ".concat(pageNumber), {
                        withAuth: true
                    }).then(function(data) {
                        data.results = data.results.map(models_giftReminders__WEBPACK_IMPORTED_MODULE_3__/* .toListOption */ .r_);
                        return data;
                    })
                ];
            });
        }),
        onError: function(e) {
            utils_logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .ZP.error({
                err: e,
                source: "Reminders API"
            }, "error: unable to retrieve reminders");
        },
        staleTime: 1000 * 60 * 5
    }), reminders = ref4.data, status = ref4.status;
    var getReminders = function() {
        api_client__WEBPACK_IMPORTED_MODULE_6__/* ["default"].invalidateQueries */ .Z.invalidateQueries({
            queryKey: [
                "reminders"
            ]
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var number = router.query.page == undefined || "" ? "1" : router.query.page;
        setPageNumber(number);
    }, [
        router.query.page
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(RemindersContext.Provider, {
        value: {
            remindersData: reminders,
            getReminders: getReminders,
            status: status,
            notification: notification,
            setNotification: setNotification,
            modalState: modalState,
            setModalState: setModalState,
            reminderInstanceId: reminderInstanceId,
            setReminderInstanceId: setReminderInstanceId
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RemindersProvider);


/***/ }),

/***/ 96466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ef": function() { return /* binding */ formDataToDto; },
/* harmony export */   "P4": function() { return /* binding */ toSelectOption; },
/* harmony export */   "jw": function() { return /* binding */ ReminderActivityType; },
/* harmony export */   "lr": function() { return /* binding */ ReminderVia; },
/* harmony export */   "r_": function() { return /* binding */ toListOption; }
/* harmony export */ });
/* harmony import */ var spacetime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79402);

var toSelectOption = function(o) {
    return {
        value: o.uid,
        label: o.title,
        iconUrl: o === null || o === void 0 ? void 0 : o.thumb_image,
        hoverIconUrl: o === null || o === void 0 ? void 0 : o.hover_image
    };
};
var occasionType = function(o) {
    return {
        uid: o.uid,
        title: o.title,
        notificationHeader: o.notification_header,
        thumbImage: o.thumb_image,
        hoverImage: o.hover_image,
        iconImage: o.icon_image,
        calendarDotColour: o.calendar_dot_colour,
        recurrenceType: o.recurrence_type,
        hidden: o.hidden,
        nextOccurrenceInCurrentLocale: o.next_occurence_in_current_locale
    };
};
var toListOption = function(o) {
    return {
        uid: o.uid,
        archivedAt: o.archived_at,
        customer: o.customer,
        nextOccurrenceDate: o.next_occurrence_date,
        heading: o.heading,
        recipientName: o.recipient_name,
        relationship: o.relationship,
        occasion: occasionType(o.occasion),
        occasionDate: o.occasion_date,
        sendViaEmail: o.send_via_email,
        sendViaSms: o.send_via_sms,
        orderNumber: o.order_number
    };
};
var formDataToDto = function(data, orderNumber) {
    return {
        recipient_name: data.name,
        relationship: data.relationship.value,
        occasion: data.occasion.value,
        occasion_date: (0,spacetime__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.date).format("{year}-{iso-month}-{date-pad}"),
        send_via_email: data.sendViaEmail,
        send_via_sms: data.sendViaSms,
        order_number: orderNumber
    };
};
var ReminderActivityType;
(function(ReminderActivityType) {
    ReminderActivityType["Save"] = "save";
    ReminderActivityType["New"] = "new";
})(ReminderActivityType || (ReminderActivityType = {}));
var ReminderVia;
(function(ReminderVia) {
    ReminderVia["Both"] = "both";
    ReminderVia["Email"] = "email";
    ReminderVia["Sms"] = "sms";
})(ReminderVia || (ReminderVia = {}));


/***/ }),

/***/ 77501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ generateUniqueReminderId; }
/* harmony export */ });
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25934);

/**
 * Generates the unique reminder ID
 */ function generateUniqueReminderId() {
    var timeStamp = Date.now().toString();
    return timeStamp.concat((0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)());
}


/***/ })

}]);